import { ChakraTheme } from "@chakra-ui/react";
import colors from "./colors";

export const dropShadowCardSize = "4px";

const shadows: ChakraTheme["shadows"] = {
  small: `0 1px 4px ${colors.shadowGray}`,
  medium: `0 1px 12px ${colors.shadowGray}`,
  large: `0 1px 20px grey`,
  xlarge: `0 1px 40px ${colors.shadowGray}`,
  hover: `0 10px 2px ${colors.shadowGray}`,
  button: `0 1px 4px ${colors.shadowGray}`,
  card: `0 0px ${dropShadowCardSize} grey`,
};

export default shadows;
